$shm_hitalama_map_widget_float_chrome_telegram $shm_hitalama_map_widget_float_form_custom
	chat_id? \
	auto /
		^
		<= rpc_listener null
		<= require_id null
	Content_by_type_override* *any
		any
			<= Textarea*
		string
			<= Textarea* $mol_textarea
				value? <=> field_value*?
		textarea
			<= Textarea*
		date
			<= Date*
		period
			<= Period*
		file
			<= File*
